export default __webpack_public_path__ + "static/media/p4.813c4072.jpeg";